export default __webpack_public_path__ + "static/tb_helles_01_EN-27e2e84ae7c9f05bf9514592650e70a9.svg";